import React from 'react';
import { connect } from 'react-redux';
import { estEnCoursDeChargement } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Chargement from '../Chargement';
import Tableau from '../Tableau';
import Adresse from '../Adresse';
import Contact from '../Contact';

const AlertePasDeFournisseurs = () => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Il n&apos;y a pas de founisseurs pour cette copropriété.</h1>
    </div>
);

const Entete = (
    <tr>
        <th>Nom</th>
        <th>Adresse</th>
        <th>Téléphone</th>
        <th>Mobile</th>
        <th>E-mail</th>
    </tr>
);

const LigneFournisseur = ({ Nom, Adr, LsContacts }) => (
    <tr>
        <td>{Nom}</td>
        <td>
            <Adresse {...Adr} uneLigne />
        </td>
        {LsContacts.map((contact, i) => <td key={i}>{contact.Ref && <Contact {...contact} uneLigne />}</td>)}
    </tr>
);

const PageFournisseurs = ({ Fournisseurs }) => {
    if (estEnCoursDeChargement(Fournisseurs)) return <Chargement />;

    const Lignes = Fournisseurs.map((fournisseur, i) => (
        <LigneFournisseur key={i} {...fournisseur} Adr={fournisseur.Adresse} />
    ));

    return Fournisseurs.length > 0 ? <Tableau Entete={Entete} Lignes={Lignes} /> : <AlertePasDeFournisseurs />;
};
PageFournisseurs.displayName = 'PageFournisseurs';
PageFournisseurs.requiredProps = [
    'Fournisseurs', // Liste des fournisseurs
];

function mapStateToProps({ CopStore: { Fournisseurs } }) {
    return {
        Fournisseurs,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(PageFournisseurs));



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageFournisseurs.js